import {createStore} from 'vuex'
import user from "./modules/user";
import permission from "./modules/permission";

const store = createStore({
    state: {
        open_notice: false,
        window_width: window.innerWidth,
        toggleNav: false, // 侧边栏展开状态
    },
    modules: {
        user,
        permission,
    },
    getters: {
        token: state => state.user.token,
        roles: state => state.user.roles,
        hasAuth: state => state.permission.hasAuth,
        permissionRoutes: state => state.permission.routes,
        logo: state => state.user.logo,
        theme_color: state => state.user.theme_color,
    },
    mutations: {
        SET_NOTICE: (state, data) => {
            state.open_notice = data;
        },
        SET_WINDOW_WIDTH: (state, data) => {
            state.window_width = data;
        },
        SET_TOGGLENAV: (state, data) => {
            state.toggleNav = data;
        },
    }
})

export default store